import { Button } from '@mui/material';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { usePallet } from '../contexts/PalletContext';
import CircularProgress from '@mui/material/CircularProgress';


const LabelCount = styled.span`
    padding: 3px 9px;
    //margin-left: 10px;
    border-radius: 26px;
    background-color: ${(props => props.active ? "white" : "#F2F2F2")};
    color: ${(props => props.active ? props.pallet.textColorQuintenary : "#9B9B9B")};
    font-size: ${(props => props.pallet.fontSize.smallButton)};
    font-weight: ${(props => props.pallet.fontWeight.subtitle)};
    width: fit-content;
`;




const ButtonCount = (props: {
    item: {
        key: string,
        label: string,
        total: number
    },
    active: boolean,
    style?: React.CSSProperties,
    desligaLoading?: React.Dispatch<React.SetStateAction<boolean>>,
    desligaLoadingClickAba?: number,
    loading?: boolean,
    onClick: (event: any) => void,
    liberar?: boolean
}) => {

    useEffect(() => {
        props && props.desligaLoading && props.desligaLoading(false)
    }, [props.item.total, props.desligaLoadingClickAba])

    const { pallet } = usePallet();

    return (
        <Button
            onClick={(e) => { props.onClick(e) }}
            key={props.item.key}
            title={props.item.label}
            disabled={props.liberar}
            variant="outlined"
                style={{
                fontFamily: `${pallet.general.fontFamily}`,
                fontSize: `${pallet.fontSize.titleWidgets}`,
                fontWeight: pallet.general.weight_bold,
                color: `${props.active ? "white" : "#9B9B9B"}`,
                border: `1px solid ${props.active ? pallet.general.color2 : "#D8D8D8"}`,
                borderRadius: "6px",
                alignItems: "center",
                letterSpacing: "1px",
                padding: "3 5px",
                marginRight: "7px",
                ...props.style
            }}
        >

            {props.item.label}
            <span>&nbsp;&nbsp;</span>
            <LabelCount pallet={pallet} active={props.active} key={props.item.key} title={props.item.label}>
                {props.loading ?
                    <CircularProgress size={15} style={{ color: `${pallet.color.primary.background}`, position: 'static' }} />
                    :
                    props.item.total}
            </LabelCount>


        </Button>
    )
}



export default ButtonCount;